import React from "react";
import { Link } from "react-router-dom";
import Navbar2 from "../Components/Navbar2";
import "./PublicPageState.css";

export default function NotFound() {
  return (
    <>
      <Navbar2 />
      <main className="public-page-state">
        <p>404</p>
        <h1>Page not found</h1>
        <p>The page may have moved or the address may be incorrect.</p>
        <Link to="/">Return to Antrazal</Link>
      </main>
    </>
  );
}
